var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('public-title',{attrs:{"showBack":_vm.isGroup}},[_vm._v("日历管理")]),_c('div',{staticClass:"load-area"},[_c('calendar',{staticClass:"p-4 bg-white"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }